/*
 * Shilajit Global — PDP behaviour.
 *
 * Two jobs:
 *   1. Show/hide the sticky mobile buy bar based on whether the real
 *      add-to-cart button is on screen.
 *   2. Keep the sticky bar's price in sync when the variant changes.
 *
 * IntersectionObserver rather than a scroll listener: no layout thrash, and
 * it costs nothing when the user is not scrolling.
 */
(function () {
  'use strict';

  var bar = document.querySelector('[data-sg-sticky-buy]');
  if (!bar) return;

  // The canonical add-to-cart lives inside the product form.
  var anchor = document.querySelector('product-form .product-form__submit')
    || document.querySelector('.product-form__submit');

  if (!anchor) {
    // No buy button on the page (e.g. a fully sold-out product with the form
    // suppressed). Leave the bar hidden rather than showing a dead control.
    return;
  }

  bar.hidden = false;

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '0px 0px -80px 0px' }
    );
    observer.observe(anchor);
  } else {
    // Very old browser: show it always rather than never.
    bar.classList.add('is-visible');
  }

  // Dawn publishes variant changes on its pubsub bus. Subscribe if present,
  // and fall back to watching the price node if the API is not available.
  var priceNode = bar.querySelector('[data-sg-sticky-price]');
  if (!priceNode) return;

  function syncPrice() {
    var source = document.querySelector('.price__container .price-item--sale')
      || document.querySelector('.price__container .price-item--regular');
    if (source) priceNode.textContent = source.textContent.trim();
  }

  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
    window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () {
      // Let Dawn finish repainting the price block before reading it.
      window.requestAnimationFrame(syncPrice);
    });
  } else {
    var priceContainer = document.querySelector('.price__container');
    if (priceContainer && 'MutationObserver' in window) {
      new MutationObserver(syncPrice).observe(priceContainer, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }
})();
